import React from 'react';
import { useSelector } from 'react-redux';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Card } from 'antd';
import './VisitorGraph.css'; // Include the custom CSS file

const VisitorStatsChart = () => {
  // Accessing the visitors data from Redux store
  const { totalVisitorsToday, totalVisitorsThisWeek, totalVisitorsThisMonth, totalVisitorsThisYear } = useSelector(state => state.dashboard.data);

  // Prepare the data for the chart
  const data = [
    { name: 'Today', visitors: totalVisitorsToday },
    { name: 'This Week', visitors: totalVisitorsThisWeek },
    { name: 'This Month', visitors: totalVisitorsThisMonth },
    { name: 'This Year', visitors: totalVisitorsThisYear }
  ];

  return (
    <Card className="visitor-stats-card" title="Visitor Statistics Comparison" bordered={false}>
      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="visitors" stroke="#8884d8" activeDot={{ r: 8 }} />
        </LineChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default VisitorStatsChart;


